import { DOLink as WalrusDOLink } from '@do/walrus';
import styled from 'styled-components';

interface Props {
  color?: string;
}

const DOLink = styled(WalrusDOLink)<Props>`
  color: ${(p) => p.color || 'inherit'};
  text-decoration: underline;

  font-family: 'JetBrains Mono', monospace;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
`;

export default DOLink;
